module.exports = "/_next/static/images/budvnitstvo-d0479919de1c79e2a6e95c89cfae41fd.svg";